import classes from "./Slideshow.module.css";
import {Fragment, useEffect, useState} from "react";
import axios from "axios";
import {path} from "../../routes";

const Slideshow = (props) =>{
    const [loadedSlides, setLoadedSlides] = useState(Array.isArray(props.slideshow) ? props.slideshow : []);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [, setroomsABCD] = useState(props.slideshowAD);
    const [, setroomsEF] = useState(props.slideshowEF);

    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    // Když se slideshow změní (např. přidání/smazání obrázku), musíme props propsat do stavu.
    useEffect(() => {
        const next = Array.isArray(props.slideshow) ? props.slideshow : [];
        setLoadedSlides(next);
        setCurrentIndex((prev) => {
            if (next.length === 0) return 0;
            return prev % next.length;
        });
    }, [props.slideshow]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                if (!loadedSlides || loadedSlides.length === 0) return 0;
                return (prevIndex + 1) % loadedSlides.length;
            });
        }, 15000);

        const resetVal = async () => {
            await axios.post(`${path}/updateReset/17`)
        }
        const getReset = async () =>{
            try {
                const response = await axios.get(`${path}/getReset/17`);
                //console.log(response.data[0].needUpdate);
                if (response.data[0].needUpdate === 1)
                {
                    console.log("update")
                    resetVal()
                    window.location.reload();
                }
                else {
                    console.log("no update")
                }
            }
            catch (error){

            }
        }

        const send = async () => {
            try {
                const response = await axios.get(`${path}/getDayListV2?orgID=AC9D7FD5-E333-4B1E-9043-4697568313B7&&day=${getTime()}`);
                if (response.data.length > 0) {
                    props.jump(7)
                } else {

                }

            } catch (error) {

            }
        }
        const intervalId2 = setInterval(send, 60 *  1000);
        const intervalId3 = setInterval(getReset, 60 * 1000);

        return () => {
            clearInterval(intervalId);
            clearInterval(intervalId2);
            clearInterval(intervalId3);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedSlides]);


    let SlideShow_Bistro =(<div className={classes.slide}>
            {loadedSlides && loadedSlides.length > 0 ? (
                <img
                    src={loadedSlides[currentIndex]}
                    alt={`Slide ${currentIndex + 1}`}
                    className={`${classes.slideImage} ${classes.slideEl}`}
                />
            ) : null}
          </div>)

    return (<Fragment>
        {SlideShow_Bistro}
    </Fragment>)
}

export default Slideshow